// src/pages/Login/Login.tsx
import React from 'react'
import { Alert, Button, Card, Form, Spinner } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'
import { firebaseSignIn } from '../../_services/firebase'

type LocationState = { from?: string }

export default function Login() {
  const navigate   = useNavigate()
  const location   = useLocation()
  const from       = ((location.state || {}) as LocationState).from || '/home'

  const [email,    setEmail]    = React.useState('')
  const [password, setPassword] = React.useState('')
  const [loading,  setLoading]  = React.useState(false)
  const [error,    setError]    = React.useState('')

  const onSubmit = async (e: React.FormEvent) => {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      await firebaseSignIn(email.trim(), password)
      navigate(from, { replace: true })
    } catch (err: any) {
      setError(err?.message || 'เข้าสู่ระบบไม่สำเร็จ')
    } finally {
      setLoading(false)
    }
  }

  return (
    <div
      className='d-flex justify-content-center align-items-center'
      style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}
    >
      <Card style={{ width: 420 }} className='shadow-sm'>
        <Card.Body className='p-4'>
          {/* Logo / Header */}
          <div className='text-center mb-4'>
            <div
              style={{
                width: 56, height: 56,
                backgroundColor: '#ffc107',
                borderRadius: 12,
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 10,
              }}
            >
              <i className='fa-solid fa-building-columns' style={{ fontSize: 24, color: '#fff' }} />
            </div>
            <h5 style={{ fontWeight: 800, marginBottom: 2 }}>KTFC Loan System</h5>
            <div className='text-muted' style={{ fontSize: 13 }}>ระบบจัดการสินเชื่อ ประเทศลาว</div>
          </div>

          {error && <Alert variant='danger' style={{ fontSize: 13 }}>{error}</Alert>}

          <Form onSubmit={onSubmit}>
            <Form.Group className='mb-3'>
              <Form.Label style={{ fontWeight: 600, fontSize: 14 }}>อีเมล</Form.Label>
              <Form.Control
                type='email'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder='name@example.com'
                autoComplete='email'
                required
                size='sm'
              />
            </Form.Group>

            <Form.Group className='mb-4'>
              <Form.Label style={{ fontWeight: 600, fontSize: 14 }}>รหัสผ่าน</Form.Label>
              <Form.Control
                type='password'
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder='••••••••'
                autoComplete='current-password'
                required
                size='sm'
              />
            </Form.Group>

            <Button
              type='submit'
              className='w-100'
              variant='warning'
              disabled={loading}
              style={{ fontWeight: 700 }}
            >
              {loading
                ? <><Spinner size='sm' animation='border' className='me-2' />กำลังเข้าสู่ระบบ...</>
                : 'เข้าสู่ระบบ'
              }
            </Button>
          </Form>
        </Card.Body>
      </Card>
    </div>
  )
}
